(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pvtech-slideshow"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pvt-zoom-gallery')) {
    class PvtZoomGallery extends HTMLElement {
      connectedCallback() {
        this.root = this.closest('.shopify-section') || this.parentElement;
        this.dialog = this.querySelector('.pvt-zoom');
        this.stage = this.querySelector('.pvt-zoom__stage');
        this.img = this.querySelector('.pvt-zoom__img');
        this.counter = this.querySelector('.pvt-zoom__counter');
        if (!this.root || !this.dialog || !this.stage || !this.img) return;

        this.maxScale = parseFloat(this.dataset.max) || 4;
        this.sync = this.dataset.sync === 'true';
        this.items = [];
        this.index = 0;
        this.s = 1;
        this.x = 0;
        this.y = 0;
        this.pointers = new Map();

        this.root.setAttribute('data-pvt-zoom', '');

        this._down = (e) => { this.downX = e.clientX; this.downY = e.clientY; };
        this._click = (e) => this.onRootClick(e);
        this.root.addEventListener('pointerdown', this._down, true);
        this.root.addEventListener('click', this._click, true);

        this.querySelectorAll('[data-zoom]').forEach((b) => {
          b.addEventListener('click', (e) => { e.stopPropagation(); this.action(b.dataset.zoom); });
        });

        this.stage.addEventListener('pointerdown', (e) => this.pDown(e));
        this.stage.addEventListener('pointermove', (e) => this.pMove(e));
        this.stage.addEventListener('pointerup', (e) => this.pUp(e, false));
        this.stage.addEventListener('pointercancel', (e) => this.pUp(e, true));
        this.stage.addEventListener('wheel', (e) => this.onWheel(e), { passive: false });
        this.dialog.addEventListener('keydown', (e) => this.onKey(e));
        this.dialog.addEventListener('close', () => this.afterClose());
      }

      disconnectedCallback() {
        if (this.root) {
          this.root.removeEventListener('pointerdown', this._down, true);
          this.root.removeEventListener('click', this._click, true);
          this.root.removeAttribute('data-pvt-zoom');
        }
        document.documentElement.classList.remove('pvt-zoom-lock');
      }

      /* ---------- Imágenes ---------- */

      keyOf(src) { return (src || '').split('?')[0]; }

      bestSrc(el) {
        let best = el.currentSrc || el.src;
        let bw = 0;
        const ss = el.getAttribute('srcset');
        if (ss) {
          ss.split(',').forEach((part) => {
            const bits = part.trim().split(/\s+/);
            const w = parseInt(bits[1], 10) || 0;
            if (bits[0] && w > bw) { bw = w; best = bits[0]; }
          });
        }
        try {
          const u = new URL(best, location.href);
          if (u.searchParams.has('width')) {
            u.searchParams.set('width', '2400');
            u.searchParams.delete('height');
          }
          best = u.toString();
        } catch (e) {}
        return best;
      }

      collect() {
        const seen = new Set();
        const out = [];
        this.root.querySelectorAll('img').forEach((el) => {
          if (this.contains(el) || el.closest('button, [data-no-zoom]')) return;
          const src = this.bestSrc(el);
          if (!src) return;
          const key = this.keyOf(src);
          if (seen.has(key)) return;
          seen.add(key);
          out.push({ el, src, key, alt: el.alt || '' });
        });
        return out;
      }

      onRootClick(e) {
        if (this.dialog.open || this.contains(e.target)) return;

        let img = e.target.closest ? e.target.closest('img') : null;
        if (!img && typeof e.clientX === 'number') {
          const el = document.elementFromPoint(e.clientX, e.clientY);
          img = el && el.closest ? el.closest('img') : null;
        }
        if (!img || !this.root.contains(img) || this.contains(img) || img.closest('button, [data-no-zoom]')) return;

        /* Si el dedo se movió, era un swipe del slideshow, no un toque */
        if (this.downX != null && Math.hypot(e.clientX - this.downX, e.clientY - this.downY) > 10) return;

        this.items = this.collect();
        const key = this.keyOf(this.bestSrc(img));
        const i = this.items.findIndex((it) => it.key === key);
        if (i < 0) return;

        e.preventDefault();
        e.stopPropagation();
        this.open(i);
      }

      open(i) {
        this.index = i;
        this.render();
        if (!this.dialog.open) this.dialog.showModal();
        document.documentElement.classList.add('pvt-zoom-lock');
      }

      render() {
        const it = this.items[this.index];
        if (!it) return;
        const n = this.items.length;
        this.reset();
        this.img.src = it.el.currentSrc || it.el.src;
        this.img.alt = it.alt;

        if (it.src !== this.img.src) {
          const idx = this.index;
          const hi = new Image();
          hi.onload = () => { if (this.index === idx) this.img.src = it.src; };
          hi.src = it.src;
        }

        this.counter.textContent = n > 1 ? (this.index + 1) + ' / ' + n : '';
        this.dialog.classList.toggle('is-single', n <= 1);
      }

      go(d) {
        const n = this.items.length;
        if (n < 2) { this.reset(); return; }
        this.index = (this.index + d + n) % n;
        this.render();
      }

      /* ---------- Zoom y desplazamiento ---------- */

      apply() {
        const r = this.stage.getBoundingClientRect();
        const w = this.img.offsetWidth * this.s;
        const h = this.img.offsetHeight * this.s;
        const mx = Math.max(0, (w - r.width) / 2);
        const my = Math.max(0, (h - r.height) / 2);
        this.x = Math.min(mx, Math.max(-mx, this.x));
        this.y = Math.min(my, Math.max(-my, this.y));
        this.img.style.transform = 'translate(' + this.x + 'px,' + this.y + 'px) scale(' + this.s + ')';
        this.dialog.classList.toggle('is-zoomed', this.s > 1.01);
      }

      reset() {
        this.s = 1;
        this.x = 0;
        this.y = 0;
        this.apply();
      }

      zoomAt(ns, cx, cy) {
        ns = Math.min(this.maxScale, Math.max(1, ns));
        this.x = cx - (cx - this.x) * (ns / this.s);
        this.y = cy - (cy - this.y) * (ns / this.s);
        this.s = ns;
        if (this.s <= 1.01) { this.s = 1; this.x = 0; this.y = 0; }
        this.apply();
      }

      point(clientX, clientY) {
        const r = this.stage.getBoundingClientRect();
        return [clientX - r.left - r.width / 2, clientY - r.top - r.height / 2];
      }

      pDown(e) {
        if (e.target.closest('button')) return;
        try { this.stage.setPointerCapture(e.pointerId); } catch (err) {}
        this.pointers.set(e.pointerId, { x: e.clientX, y: e.clientY });
        this.img.classList.add('is-dragging');

        if (this.pointers.size === 1) {
          this.sx = e.clientX;
          this.sy = e.clientY;
          this.px = this.x;
          this.py = this.y;
          this.moved = false;
          this.tapTarget = e.target;
        } else if (this.pointers.size === 2) {
          const [a, b] = [...this.pointers.values()];
          this.pd = Math.hypot(a.x - b.x, a.y - b.y) || 1;
          this.ps = this.s;
          this.moved = true;
        }
      }

      pMove(e) {
        if (!this.pointers.has(e.pointerId)) return;
        this.pointers.set(e.pointerId, { x: e.clientX, y: e.clientY });

        if (this.pointers.size >= 2) {
          const [a, b] = [...this.pointers.values()];
          const d = Math.hypot(a.x - b.x, a.y - b.y);
          const [cx, cy] = this.point((a.x + b.x) / 2, (a.y + b.y) / 2);
          this.zoomAt(this.ps * (d / this.pd), cx, cy);
          return;
        }

        const dx = e.clientX - this.sx;
        const dy = e.clientY - this.sy;
        if (Math.abs(dx) > 6 || Math.abs(dy) > 6) this.moved = true;
        if (!this.moved) return;

        if (this.s > 1) {
          this.x = this.px + dx;
          this.y = this.py + dy;
          this.apply();
        } else {
          this.img.style.transform = 'translate(' + dx + 'px,0)';
        }
      }

      pUp(e, cancelled) {
        if (!this.pointers.has(e.pointerId)) return;
        this.pointers.delete(e.pointerId);

        if (this.pointers.size === 1) {
          const p = [...this.pointers.values()][0];
          this.sx = p.x;
          this.sy = p.y;
          this.px = this.x;
          this.py = this.y;
          return;
        }
        if (this.pointers.size > 0) return;

        this.img.classList.remove('is-dragging');
        if (cancelled) { this.apply(); return; }

        if (!this.moved) {
          if (this.tapTarget === this.img) {
            if (this.s > 1) {
              this.reset();
            } else {
              const [cx, cy] = this.point(e.clientX, e.clientY);
              this.zoomAt(2.5, cx, cy);
            }
          } else if (this.s <= 1) {
            this.dialog.close();
          }
          return;
        }

        if (this.s <= 1) {
          const dx = e.clientX - this.sx;
          if (dx > 60) this.go(-1);
          else if (dx < -60) this.go(1);
          else this.reset();
        }
      }

      onWheel(e) {
        e.preventDefault();
        const [cx, cy] = this.point(e.clientX, e.clientY);
        this.zoomAt(this.s * (e.deltaY < 0 ? 1.2 : 1 / 1.2), cx, cy);
      }

      onKey(e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); this.go(1); }
        else if (e.key === 'ArrowLeft') { e.preventDefault(); this.go(-1); }
        else if (e.key === '+' || e.key === '=') { e.preventDefault(); this.action('in'); }
        else if (e.key === '-') { e.preventDefault(); this.action('out'); }
      }

      action(a) {
        if (a === 'close') this.dialog.close();
        else if (a === 'prev') this.go(-1);
        else if (a === 'next') this.go(1);
        else if (a === 'in') this.zoomAt(this.s * 1.5, 0, 0);
        else if (a === 'out') this.zoomAt(this.s / 1.5, 0, 0);
      }

      /* ---------- Al cerrar ---------- */

      afterClose() {
        document.documentElement.classList.remove('pvt-zoom-lock');
        this.reset();
        if (!this.sync) return;

        const it = this.items[this.index];
        if (!it || !it.el.isConnected) return;

        const ss = it.el.closest('slideshow-component');
        const slide = it.el.closest('slideshow-slide');
        if (ss && slide && typeof ss.select === 'function') {
          const slides = [...ss.querySelectorAll('slideshow-slide')];
          const i = slides.indexOf(slide);
          if (i >= 0) {
            try { ss.select(i); return; } catch (err) {}
          }
        }
        try {
          (slide || it.el).scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'instant' });
        } catch (err) {}
      }
    }

    customElements.define('pvt-zoom-gallery', PvtZoomGallery);
  }

  } catch(e) { console.error(e); }
})();
})();
